import moment from "moment";
import { TYPES } from "../actions";

const initialState = {
  aiConversations: []
};

export const aiConversationReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPES.ACTION_GET_ALL_AI_CONVERSATIONS_SUCCESS:
      return { ...state, 
        aiConversations: action.payload.data
      }

    case TYPES.ACTION_GET_ALL_AI_CONVERSATIONS_FAIL:
      return { ...state, aiConversations: [] };

    case TYPES.ACTION_UPDATE_AI_CONVERSATION_SUCCESS:
      return { ...state,
        aiConversations: state.aiConversations.map(conversation => 
          conversation._id === action.payload.data._id ? action.payload.data : conversation
        )
      };

    case TYPES.ACTION_UPDATE_AI_CONVERSATION_FAIL:
      return state;
      
    default:
      return state;
  }
}
